enum FieldDataSource {
  DATABASE = 'database',
  MANUALLY = 'manually'
}

export default FieldDataSource;
